// extracted by mini-css-extract-plugin
export default {"root":"Search_root__J+9mr","input":"Search_input__psDOX","icon":"Search_icon__g0ig4","clearIcon":"Search_clearIcon__c8wOL"};